import { Component, Host, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
// import { BreadcrumbsService, DetailsComponent, MasterDetailViewComponent } from '@bci/ng-core';
import {
  BreadcrumbsService,
  DetailsComponent,
  MasterDetailViewComponent
} from '@bci-web-core/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteModel } from '../../../../models/site.model';
import { SiteMasterService } from '../../../../services/site-master.service';

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss'],
  providers: [MasterDetailViewComponent]
})
export class SiteDetailComponent
  implements OnInit, OnDestroy, DetailsComponent
{
  site: SiteModel;
  form: UntypedFormGroup = new UntypedFormGroup({});

  private componentDestroyed$: Subject<any> = new Subject();
  constructor(
    @Host() public masterDetailView: MasterDetailViewComponent,
    private siteService: SiteMasterService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private breadcrumbsService: BreadcrumbsService
  ) {}
  ngOnInit(): void {
    this.form = this.formBuilder.group({
      siteId: ['', [Validators.required]],
      siteName: ['', [Validators.required]],
      industryType: [''],
      city: ['', [Validators.required]],
      nextFollowUpDate: ['', [Validators.required]],
      executionState: ['', [Validators.required]],
      leadType: ['', [Validators.required]],
      conversionFlag: ['', [Validators.required]],
      featureOpted: ['', [Validators.required]],
      industrySegment: ['', [Validators.required]],
      contactPersonName: ['', [Validators.required]],
      contactNo: ['', [Validators.required]]
    });

    // provide deep linking
    this.activatedRoute.params
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((params) => {
        this.siteService.querySingle(params['id']).subscribe((site) => {
          this.breadcrumbsService.setTemporaryTitleForPartialRoute(
            this.activatedRoute.snapshot,
            [':id'],
            site.siteName
          );
          this.site = site;
          if (site) {
            this.form.patchValue(site);
            this.masterDetailView.openDetails();
          }
        });
      });
  }

  cancel() {
    this.form.reset();
  }

  canCloseDetails(): boolean {
    if (this.form.dirty) {
      this.snackBar.open('To close the details, save your changes first.', '', <
        MatSnackBarConfig
      >{ duration: 5000 });
      return false;
    } else {
      return true;
    }
  }

  closeDetails(): boolean | Observable<boolean> {
    return this.masterDetailView.closeDetails();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(null);
    this.componentDestroyed$.complete();
  }
}
